module.exports = __webpack_public_path__ + "img/head-mv2-02.2ca73b12.jpg";